/** Determine if the given element is in the current viewport.
 *	@param {HTMLElement|undefined} elm	The node element to check. Usually elm for a component.
 *	@returns {bool}
 */
export default function inViewport(elm) {
	if (typeof elm === 'undefined') return false;

	// Bail if detached.
	if (!elm.offsetParent) return false;

	let bbox = elm.getBoundingClientRect();

	// If position and size are both 0, the element (or an ancestor) is hidden.
	if (!bbox.left && !bbox.right && !bbox.top && !bbox.bottom && !(typeof bbox.width==='number' ? bbox.width : elm.offsetWidth)) {
		return false;
	}

	let viewportHeight = window.innerHeight || document.documentElement.offsetHeight,
		viewportWidth = window.innerWidth || document.documentElement.offsetWidth;

	if (bbox.top<=viewportHeight && bbox.bottom>=0 && bbox.left<=viewportWidth && bbox.right>=0) {
		return true;
	}

	return false;
}
